module.exports = __webpack_public_path__ + "img/glamping-near-me.2.1843036.jpg";